// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Texte pouvant contenir des balises HTML limitées aux suivantes :\n\n- `<b>`, `<i>`, `<em>`, `<strong>`, `<p>`, `<br>`, `<ul>`, `<li>`.\n\nToute autre balise ou attribut sera supprimée lors de la validation\n"
export default markdown
